import { ReplaySubject } from "rxjs";
import { BelegLookupDto } from "src/app/web-api/web-api";

export class BelegSelectingEvent {
    private _selectedItem: BelegLookupDto = null;
    private _isCancelled$ = new ReplaySubject<boolean>();
    public isCancelled = false;
    public shouldSubscribeToAsyncCancellation = false;

    public constructor(selectedItem: BelegLookupDto){
        this._selectedItem = selectedItem;
    }

    public get isCancelled$() {
        return this._isCancelled$;
    }
    public get selected() {
        return this._selectedItem;
    }
}